export default __webpack_public_path__ + "static/media/studyMaterialImg.fb0855eb.svg";